import { configureStore } from '@reduxjs/toolkit';

import channelReducer from './channelSlice';
import companyInAppNotificationReducer from './company/companyInAppNotificationSlice';
import fileDownloadSlice from './fileDownloadSlice';
import tenantInAppNotificationReducer from './tenant/tenantInAppNotificationSlice';
import threadReducer from './threadSlice';

export const store = configureStore({
  reducer: {
    channel: channelReducer,
    fileDownload: fileDownloadSlice,
    tenantInAppNotification: tenantInAppNotificationReducer,
    companyInAppNotification: companyInAppNotificationReducer,
    thread: threadReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
